import {
  ArrowRightIcon,
  ArrowTrendingUpIcon,
  BanknotesIcon,
  EyeIcon,
} from '@heroicons/react/24/outline';
import React from 'react';

import usePage from '@dashboard/hooks/usePage';

import getConversionRate from '@dashboard/services/getConversionRate';

import Link from '@dashboard/components/Link';

import * as KPICard from '../components/KPICard';
import RecentSubmissions from '../components/RecentSubmissions';
import PageOverviewHeader from '../components/PageOverviewHeader';

export default function CheckoutOverview() {
  const { page } = usePage();

  const conversionRate = getConversionRate(page.submissionCount, page.visitCount);

  return (
    <div>
      <PageOverviewHeader page={page}>
        <KPICard.Container>
          <KPICard.Icon icon={BanknotesIcon} />
          <KPICard.Header>
            <KPICard.Title>Submissions</KPICard.Title>
            <KPICard.InfoTooltip>Total number of submissions</KPICard.InfoTooltip>
          </KPICard.Header>
          <KPICard.Value>{page.submissionCount}</KPICard.Value>
        </KPICard.Container>

        <KPICard.Container>
          <KPICard.Icon icon={EyeIcon} />
          <KPICard.Header>
            <KPICard.Title>Page views</KPICard.Title>
            <KPICard.InfoTooltip>Total number of form page views</KPICard.InfoTooltip>
          </KPICard.Header>
          <KPICard.Value>{page.visitCount}</KPICard.Value>
        </KPICard.Container>

        <KPICard.Container>
          <KPICard.Icon icon={ArrowTrendingUpIcon} />
          <KPICard.Header>
            <KPICard.Title>Conversion rate</KPICard.Title>
            <KPICard.InfoTooltip>Conversion Rate (conversions ÷ views × 100)</KPICard.InfoTooltip>
          </KPICard.Header>
          <KPICard.Value>{conversionRate}%</KPICard.Value>
        </KPICard.Container>
      </PageOverviewHeader>

      <div className="mt-8">
        <div className="flex justify-between items-center ml-4">
          <h2 className="text-lg font-medium">Recent submissions</h2>

          <div>
            <Link
              href={`/pages/${page._id}/submissions`}
              className="flex items-center gap-x-1 whitespace-nowrap text-sm"
            >
              View all <ArrowRightIcon className="w-4 h-4" />
            </Link>
          </div>
        </div>

        <RecentSubmissions />
      </div>
    </div>
  );
}
